import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import props from '../../../../../../redux/props'
import { setLocal } from '../../../../../../redux/action/local'

const WholeLoan = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewPurchaseProfile({ ...purchaseProfile, wholeLoan: { ...purchaseProfile.wholeLoan, [key]: value } }))
    dispatch(setLocal(props.PURCHASE_PROFILE, { ...purchaseProfile, wholeLoan: { ...purchaseProfile.wholeLoan, [key]: value } }))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.whole-loan.from']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.wholeLoan.from}
                onChange={update('from')}
                placeholder={translations['my-objects.pipeline.assets-class.whole-loan.from']}
              />
            </div>
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.wholeLoan.until}
                onChange={update('until')}
                placeholder={translations['my-objects.pipeline.assets-class.whole-loan.until']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WholeLoan
